export default {
  header: {
    userCenter: 'User Center',
    userSettings: 'User Settings',
    logout: 'Logout',
    login: 'Login',
    register: 'Register',
  },
};
